import { post } from '@/common/request/index';

const OPTIONS = {
  isMock: false,
  mockId: 666,
  mockSuffix: '/api',
  needHint: true,
  isTrust: true,
};

const PROPERTY_OPTIONS = {
  ...OPTIONS,
  // 同一 URL 会并发加载三个属性选项，不能按 URL 自动相互取消。
  needCancel: false,
};

export interface TrustMediaAsset {
  name?: string;
  type?: string;
  url?: string;
  [key: string]: any;
}

export interface TrustSpotLibraryParams {
  size?: number;
  page?: number;
  sortField?: string;
  sort?: 'asc' | 'desc';
  keyword?: string;
  cityIdList?: number[];
  spotPositionList?: number[];
  videoSourceFilterList?: string[];
  spotFloorList?: number[];
  indoorOrOutdoorId?: number;
  spotAreaMin?: number;
  spotAreaMax?: number;
  measuredDailyFlowType?: number;
  cpmType?: number;
  placePublicId?: number | string;
}

export interface TrustSpotLibraryItem {
  spotId?: number;
  tenantPlaceId?: number;
  modelClusterId?: number | string;
  spotName?: string;
  placeName?: string;
  cityName?: string;
  spotPosition?: string;
  spotFloor?: string;
  indoorOrOutdoor?: string;
  spotArea?: number;
  heightLimit?: number;
  measuredDailyFlow?: number;
  coverUrl?: string;
  positioningbrand?: string;
  dailyFlowSourceName?: string;
  videoSource?: string;
  videoSourceName?: string;
  retailDailyPrice?: number;
  cpm?: number;
  [key: string]: any;
}

export interface TrustSpotLibraryResponse {
  totalNum?: number;
  pageNum?: number;
  pageSize?: number;
  objectList?: TrustSpotLibraryItem[];
  meta?: Record<string, any>;
}

export interface TrustSpotLibraryCasePageParams {
  spotId: number | string;
  page: number;
  size: number;
}

export interface TrustSpotLibraryCaseItem {
  caseId?: number | string;
  coverUrl?: string;
  caseName?: string;
  startTime?: string;
  endTime?: string;
  industryId?: number;
  industryName?: string;
  tenantPlaceId?: number | string;
  tenantPlaceName?: string;
  spotId?: number | string;
  spotName?: string;
  address?: string;
  brandList?: string[];
  onShelvesStatus?: number;
}

export interface TrustSpotLibraryCasePageResponse {
  totalNum?: number;
  pageNum?: number;
  pageSize?: number;
  objectList?: TrustSpotLibraryCaseItem[];
  meta?: Record<string, any>;
}

export interface TrustSpotLibraryCaseDetailParams {
  caseId: number | string;
}

export interface TrustSpotLibraryCaseDetailResponse {
  caseId?: number | string;
  caseName?: string;
  pictureUrls?: string[];
  startTime?: string;
  endTime?: string;
  industryId?: number;
  industryName?: string;
  tenantPlaceId?: number | string;
  tenantPlaceName?: string;
  spotId?: number | string;
  spotName?: string;
  address?: string;
  brandNames?: string[];
  description?: string;
}

export interface TrustRecommendPageParams {
  size?: number;
  page?: number;
  sortField?: string;
  sort?: string;
  taskId?: number | string;
  keyword?: string;
  spotName?: string;
  placeName?: string;
  cityName?: string;
  statusList?: number[];
  [key: string]: any;
}

export interface TrustRecommendItem {
  id?: number;
  taskId?: number;
  spotId?: number;
  placeId?: number;
  cityId?: number;
  categoryIds?: string;
  spotName?: string;
  placeName?: string;
  cityName?: string;
  locationType?: string;
  floor?: string;
  heightLimit?: number;
  area?: number;
  measuredDailyFlow?: number;
  dailyPrice?: number;
  cpm?: number;
  estimatedRoi?: number;
  suggestRent?: number;
  suggestRentUnit?: number;
  videoSource?: string;
  status?: number;
  bidPrice?: number;
  bidStartDate?: string;
  bidEndDate?: string;
  bidTime?: string;
  propertyPrice?: number;
  propertyStartDate?: string;
  propertyEndDate?: string;
  confirmTime?: string;
  signedFlag?: boolean;
  signedTime?: string;
  [key: string]: any;
}

export interface TrustRecommendPageResponse {
  totalNum?: number;
  pageNum?: number;
  pageSize?: number;
  objectList?: TrustRecommendItem[];
  meta?: Record<string, any>;
}

export interface TrustRecommendCountParams {
  taskId: number | string;
}

export interface TrustRecommendCountResponse {
  recommendCount?: number;
  hasUnreadRecommendSpot?: boolean;
}

export interface TrustRecommendInquiryParams {
  recommendId: number;
  bidStartDate: string;
  bidEndDate: string;
  bidPrice: number;
}

export interface TrustRecommendAddParams {
  taskId: number;
  spotId: number;
}

export interface TrustSpotDetailParams {
  spotId: number | string;
}

export interface TrustSpotDetailResponse {
  spotId?: number | string;
  tenantPlaceId?: number | string;
  modelClusterId?: number | string;
  spotPublicId?: number | string;
  placePublicId?: number | string;
  placeName?: string;
  spotName?: string;
  indoorOrOutdoor?: string;
  spotFloor?: string;
  spotPosition?: string;
  stallTime?: string;
  specLW?: string;
  heightLimit?: string | number;
  positioningbrand?: string;
  bearing?: string;
  exhibitionDirection?: string;
  passageNumber?: string | number;
  stallPosition?: string;
  positionArea?: string;
  acceptDiscounts?: boolean;
  acceptFair?: boolean;
  acceptVendingMachine?: boolean;
  prohibitCategory?: string;
  propertyRequirements?: string;
  weekdayFlow?: string;
  weekendFlow?: string;
  dailyFlow?: string;
  retailDailyPrice?: number;
  cpm?: number;
  spotPicture?: TrustMediaAsset[];
  spotVideo?: TrustMediaAsset[];
  spotDescription?: string;
  propertyService?: string;
  isWaterSupply?: boolean;
  isNetSupply?: boolean;
  warehouseSupport?: boolean;
  mediaSupport?: boolean;
  bookDateAdvance?: string | number;
  isUnsubscribed?: boolean;
  isDateChangeable?: boolean;
  activityTogether?: boolean;
  needDeposit?: boolean;
  isInvoice?: boolean;
  needApproval?: boolean;
  needGroundProtection?: string;
  groundProtectionDetail?: string;
  needCargoLift?: string;
  cargoLiftBearing?: string;
  dischargeSite?: string;
  unloadingZone?: string;
  garageHeight?: string | number;
  admissionTime?: string;
  doorWidth?: string | number;
  admissionRoute?: TrustMediaAsset[];
  admissionRouteDes?: string;
  admissionEntrance?: TrustMediaAsset[];
  admissionEntranceName?: string;
  supportAutoShow?: boolean;
  materialconsistency?: string;
  carAdmissionDoorWidth?: string | number;
  carAdmissionRoute?: TrustMediaAsset[];
  carAdmissionRouteDes?: string;
  carAdmissionEntrance?: TrustMediaAsset[];
  carAdmissionEntranceName?: string;
  isPowerSupply?: boolean;
  powerRate?: string;
  voltage?: string | number;
  powerPosition?: string;
  powerDistance?: string | number;
  powerRoute?: TrustMediaAsset[];
  powerRemark?: string;
  powerSupply?: string | number;
  fireExtinguisherType?: string;
  fireExtinguisherNum?: string | number;
  fireExtinguisherWeight?: string | number;
  needFireExtinguisherBox?: boolean;
  admissionRemark?: string;
  [key: string]: any;
}

export interface TrustPlaceDetailParams {
  tenantPlaceId: number | string;
}

export interface TrustPlaceDetailResponse {
  provinceId?: number;
  provinceName?: string;
  cityId?: number;
  cityName?: string;
  districtId?: number;
  districtName?: string;
  placeName?: string;
  address?: string;
  businessCircle?: string;
  managerName?: string;
  builtArea?: string | number;
  constructionTime?: string;
  weekdayFlow?: string;
  weekendFlow?: string;
  dailyFlow?: string;
  geofence?: string;
  placePicture?: TrustMediaAsset[];
  placeVideo?: TrustMediaAsset[];
  placeDescription?: string;
  floorPlan?: TrustMediaAsset[];
  floorBrand?: string;
  attractInvestmentPPT?: TrustMediaAsset[];
  multipleMeridiansPPT?: TrustMediaAsset[];
  propertyManagementBrand?: string;
  totalBrands?: string | number;
  mallType?: string;
  projectOrientation?: string;
  commercialVolume?: string | number;
  openingTime?: string;
  representativeBrand?: string;
  secondaryBrands?: string;
  bizTypeDist?: string;
  annualSales?: string | number;
  lastYearSales?: string | number;
  salesTarget?: string | number;
  acceptDevelopment?: string;
  enterDocument?: string;
  entryinformationtemplate?: TrustMediaAsset[];
  supportingFacilities?: string;
  hasRestaurant?: string;
  hasParkingSpace?: string;
  haveSubway?: string;
  [key: string]: any;
}

export interface TrustSpotVideoParams {
  spotId: number | string;
  client: 'WEB' | 'APP';
  storeIds?: number[];
}

export interface TrustSpotVideoResponse {
  source?: string;
  url?: string;
  imgUrl?: string;
  rtmpUrl?: string;
  deviceId?: number;
  storeId?: number;
  flowTime?: string;
  [key: string]: any;
}

export interface TrustSpotPropertyOptionsParams {
  propertyIdentification: 'spotFloor' | 'spotPosition' | 'indoorOrOutdoor';
}

export interface TrustSpotPropertyOption {
  id?: number;
  name?: string;
  [key: string]: any;
}

/**
 * 托管点位库分页查询
 * https://yapi.lanhanba.com/project/666/interface/api/99504
 */
export function postTrustSpotLibraryPage(params: TrustSpotLibraryParams) {
  return post('/brand/spot/library/page', params, OPTIONS) as Promise<TrustSpotLibraryResponse>;
}

/**
 * 点位历史案例分页查询
 * https://yapi.lanhanba.com/project/666/interface/api/99618
 */
export function postTrustSpotLibraryCasePage(params: TrustSpotLibraryCasePageParams) {
  return post('/brand/spot/library/case/page', params, OPTIONS) as Promise<TrustSpotLibraryCasePageResponse>;
}

/**
 * 点位历史案例详情查询
 * https://yapi.lanhanba.com/project/666/interface/api/99620
 */
export function postTrustSpotLibraryCaseDetail(params: TrustSpotLibraryCaseDetailParams) {
  return post('/brand/spot/library/case/detail', params, OPTIONS) as Promise<TrustSpotLibraryCaseDetailResponse>;
}

/**
 * 推荐分页查询
 * https://yapi.lanhanba.com/project/666/interface/api/99526
 */
export function postTrustRecommendPage(params: TrustRecommendPageParams) {
  return post('/brand/task/recommend/page', params, OPTIONS) as Promise<TrustRecommendPageResponse>;
}

/**
 * 查询推荐点位数量
 * https://yapi.lanhanba.com/project/666/interface/api/99694
 */
export function postTrustRecommendCount(params: TrustRecommendCountParams) {
  return post('/brand/task/recommend/count', params, OPTIONS) as Promise<TrustRecommendCountResponse>;
}

/**
 * 发起询价
 * https://yapi.lanhanba.com/project/666/interface/api/99528
 */
export function postTrustRecommendInquiry(params: TrustRecommendInquiryParams) {
  return post('/brand/task/recommend/inquiry', params, OPTIONS) as Promise<{ success?: boolean }>;
}

/**
 * 手动新增推荐点位
 * https://yapi.lanhanba.com/project/666/interface/api/99566
 */
export function postTrustRecommendAdd(params: TrustRecommendAddParams) {
  return post('/brand/task/recommend/add', params, OPTIONS) as Promise<{ success?: boolean }>;
}

/**
 * 托管点位详情
 * https://yapi.lanhanba.com/project/666/interface/api/99516
 */
export function postTrustSpotDetail(params: TrustSpotDetailParams) {
  return post('/brand/spot/detail', params, OPTIONS) as Promise<TrustSpotDetailResponse>;
}

/**
 * 托管项目详情
 * https://yapi.lanhanba.com/project/666/interface/api/99518
 */
export function postTrustPlaceDetail(params: TrustPlaceDetailParams) {
  return post('/brand/place/detail', params, OPTIONS) as Promise<TrustPlaceDetailResponse>;
}

/**
 * 托管点位视频
 * https://yapi.lanhanba.com/project/666/interface/api/99502
 */
export function postTrustSpotVideo(params: TrustSpotVideoParams) {
  return post('/brand/spot/video', params, OPTIONS) as Promise<TrustSpotVideoResponse>;
}

/**
 * 托管点位属性选项
 * https://yapi.lanhanba.com/project/666/interface/api/99500
 */
export function postTrustSpotPropertyOptions(params: TrustSpotPropertyOptionsParams) {
  return post('/common/selection/spotPropertyOptions', params, PROPERTY_OPTIONS) as Promise<TrustSpotPropertyOption[]>;
}
